import styled from 'styled-components';

import { HOME, MOBILE } from '../../../../theme/tokens';
import { pulseCard } from '../../../../theme/mixins';
import { Text } from '../../../../components';

/** Three equal KPI tiles, collapsing to one column on mobile. */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

export const Tile = styled.div`
  ${pulseCard}
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
`;

export const TileLabel = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  color: ${HOME.t300};
`;

export const TileValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  color: ${HOME.t50};
`;

export const TileFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  row-gap: 4px;
`;

export const TileVs = styled(Text)`
  font-size: 13px;
  font-weight: 400;
  color: ${HOME.t600};
  white-space: nowrap;
`;
